import axios from "axios";
import { Controller } from "@hotwired/stimulus";
export default class extends Controller {
  static targets = ["form"];

  resetPassword(event) {
    event.preventDefault();
    const form = this.formTarget;
    $(".send-instrustructions").attr("disabled", "disabled");

    axios
      .post(form.action, $(form).serialize())
      .then(response => {
        let data = response.data;
        if (data.error != undefined) {
          showNotification("danger", data.error);
        } else {
          $(".card .forgot-password").addClass("hidden");
          $(".card .reset-password-instruction").removeClass("hidden");

          if (data.invited) {
            alertInvitedNotRegistered(
              data.title,
              data.message,
              data.expired,
              data.resendInvitationUrl,
              data.loginUrl
            );
          } else {
            bootbox.alert({
              title: data.title,
              message: data.message,
              callback: function () {
                window.location = data.loginUrl;
              }
            });
          }
        }
      })
      .catch(error => {
        showNotification(
          "danger",
          "Failed to process your reset password request, please make sure you entered a valid email."
        );
      });
  }
}
